module.exports = __webpack_public_path__ + "img/Photo_5__Construction_985_98_2.994a9a23.jpg";